export enum ActirisErrorCode {
    None = 0,
    Forbidden = 1,
}
